import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup, Validators,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS007KaiyakuEntryOutVO,} from '@pages/sms007-kaiyaku-entry/sms007-kaiyaku-entry-out-vo';
import * as Const_SMS007 from '@pages/sms007-kaiyaku-entry/sms007-kaiyaku-entry-const';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms007-kaiyaku-entry',
  templateUrl: './sms007-kaiyaku-entry.html',
  styleUrls: ['./sms007-kaiyaku-entry.scss',],
})
/*****************************************************/
/* 処　理：SMS007 解約・退去予定日登録 画面
/*
/* 概　要：解約・退去の登録 処理
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS007KaiyakuEntry implements OnInit {
  smsForm!: FormGroup;                      // 画面フォーム
  loginUserVO!: LoginUserVO;                // セッション情報
  sms007ApiRetVO!: SMS007KaiyakuEntryOutVO; // API返却情報
  dispId!: string;                          // ログ表示用ID
  lngType!: string;                         //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン操作可否
  isEnableBtnSend = true;
  isEnableBtnMenu = true;

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblKaiyakuDateYYYY!: string;
  public lblKaiyakuDateMM!: string;
  public lblKaiyakuDateDD!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblMessage05!: string;
  public lblMessage06!: string;
  public lblMessage07!: string;
  public lblMessage08!: string;
  public lblBtnSend!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00701M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      txtTaikyoDateYYYY: [
        '',
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          this.validationService.numericFromToValidator(1753, 9998),
        ],
      ],
      txtTaikyoDateMM: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
          this.validationService.numericFromToValidator(1, 12),
        ],
      ],
      txtTaikyoDateDD: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
          this.validationService.numericFromToValidator(1, 31),
        ],
      ],
    });

    // 初期表示
    this.formInit();
  }


  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00701M001I', this.dispId, Const_SMS007.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS007.API_INIT_PATH, Const_SMS007.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00701M002I', this.dispId, Const_SMS007.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00701M001E', this.dispId, Const_SMS007.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 07 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.dispId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 07 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 07 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 07 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00701M003I', btnName, this.dispId);
    this.httpClient.post<SMS007KaiyakuEntryOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00701M004I', btnName, this.loginUserVO.shouninNo);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00701M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00701M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 07 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS007KaiyakuEntryOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS007KaiyakuEntryOutVO): void {

    this.logger.debug(this.dispId + ' ■ 07 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 07 ApiOut  sei ：' + resp['sei']);
    this.logger.debug(this.dispId + ' ■ 07 ApiOut  mei ：' + resp['mei']);

    // 画面文言（言語区分により変換）
    // {1}　{2} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M002F',},  false) || '';
    // 退去日（退去予定日）を入力してください。
    this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M003F',},  false) || '';
    // YYYY
    this.lblKaiyakuDateYYYY = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M004F',},  false) || '';
    // 年
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M005F',},  false) || '';
    // MM
    this.lblKaiyakuDateMM = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M006F',},  false) || '';
    // 月
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M007F',},  false) || '';
    // DD
    this.lblKaiyakuDateDD = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M008F',},  false) || '';
    // 日
    this.lblMessage05 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M009F',},  false) || '';
    // 解約手続きは、契約内容および管理会社への確認をお願いいたします。
    this.lblMessage06 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M010F',},  false) || '';
    // この画面で解約受付は出来ませんので、ご注意ください。
    this.lblMessage07 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M011F',},  false) || '';
    // （オリコフォレントインシュアにのみ通知されます）
    this.lblMessage08 = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M012F',},  false) || '';
    // 送信
    this.lblBtnSend = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M013F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M014F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS007' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 07 end---- getInitApiReturnInfo');
    return;
  }


  /* **************************************************************
   * 送信ボタン押下
   * **************************************************************/
  executeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00701M005I', this.dispId, Const_SMS007.BTN_EXECUTE_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 画面項目制御
      this.enabledChange(false);

      // 解約日登録API処理 呼出
      this.doEexecute(Const_SMS007.API_EXECUTE_PATH, Const_SMS007.BTN_EXECUTE_NAME);

    } catch (ex) {
      this.logger.error('SMS00701M002E', this.dispId, Const_SMS007.BTN_EXECUTE_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック
   * @returns true/false
   */
  inputCheck(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 07 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 退去日(年)
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtTaikyoDateYYYY.value)) {
      this.logger.debug('■ 07 退去日(年)：必須NG');
      this.smsForm.controls.txtTaikyoDateYYYY.setErrors({required: true,});
      this.smsForm.controls.txtTaikyoDateYYYY.markAsDirty();
      isRet = false;
    }
    // 退去日(月)
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtTaikyoDateMM.value)) {
      this.logger.debug('■ 07 退去日(月)：必須NG');
      this.smsForm.controls.txtTaikyoDateMM.setErrors({required: true,});
      this.smsForm.controls.txtTaikyoDateMM.markAsDirty();
      isRet = false;
    }
    // 退去日(日)
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtTaikyoDateDD.value)) {
      this.logger.debug('■ 07 退去日(日)：必須NG');
      this.smsForm.controls.txtTaikyoDateDD.setErrors({required: true,});
      this.smsForm.controls.txtTaikyoDateDD.markAsDirty();
      isRet = false;
    }

    // ------------------------------------------
    // 日付型の整合性チェック
    // ------------------------------------------
    const taikyoDate = this.smsForm.controls.txtTaikyoDateYYYY.value + this.smsForm.controls.txtTaikyoDateMM.value + this.smsForm.controls.txtTaikyoDateDD.value;
    if (!this.validationService.isDateYYYYMMDD(taikyoDate)) {
      this.logger.debug('■ 07 退去日：isDateYYYYMMDD NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 07 入力チェック終了');

    return isRet;
  }

  /**
   * 解約日登録API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private doEexecute(path: string, btnName: string): void {

    // ログ出力
    this.logger.info('SMS00701M001I', this.dispId, btnName);
    this.logger.debug(this.dispId + ' ■ 07 start-- doEexecute');

    const taikyoDate = this.smsForm.controls.txtTaikyoDateYYYY.value +
                       this.smsForm.controls.txtTaikyoDateMM.value +
                       this.smsForm.controls.txtTaikyoDateDD.value;

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
      taikyoDate:  taikyoDate,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 07 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 07 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 07 ApiIn   shouninNo    ：' + apiVo.shouninNo);
    this.logger.debug(this.dispId + ' ■ 07 ApiIn   taikyoDate   ：' + apiVo.taikyoDate);

    // 解約日登録API
    this.logger.info('SMS00701M003I', this.dispId, btnName);
    this.httpClient.post<SMS007KaiyakuEntryOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00701M004I',this.dispId,  btnName);
        if (resp != null) {
          // 手続き完了画面に遷移
          this.nextPage();

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00701M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        this.logger.error('SMS00701M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 07 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 画面遷移処理
   */
  nextPage(): void{
    this.logger.debug(this.dispId + ' ■ 07 → 10 画面遷移');
    this.windowService.transit<null>('SMS010', null);
  }

  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00701M005I', this.dispId, Const_SMS007.BTN_BACKMENU_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00701M002E', this.dispId, Const_SMS007.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 07 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

  /**
   * 画面項目の制御
   * @param {boolean} isEnabledFlg
   */
  enabledChange(isEnabledFlg: boolean): void {
    this.isEnableBtnSend = isEnabledFlg;
    this.isEnableBtnMenu = isEnabledFlg;
  }

}
